import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { TextInput } from 'components/Form'

type Props = {
  breadWidth: number
  breadDepth: number
  breadHeight: number
  handleBreadWidth: (event: ChangeEvent<HTMLInputElement>) => void
  handleBreadDepth: (event: ChangeEvent<HTMLInputElement>) => void
  handleBreadHeight: (event: ChangeEvent<HTMLInputElement>) => void
}

const ProductSizeForm: FC<Props> = React.memo((props) => {
  const { breadWidth, breadDepth, breadHeight, handleBreadWidth, handleBreadDepth, handleBreadHeight } = props

  return (
    <div>
      <div className={styles.column_three}>
        <div className={`${styles.column_three__item} ${text.font_small}`}>幅</div>
        <Spacer size={8} />
        <div className={`${styles.column_three__item} ${text.font_small}`}>奥行き</div>
        <Spacer size={8} />
        <div className={`${styles.column_three__item} ${text.font_small}`}>高さ</div>
      </div>
      <Spacer size={8} />
      <div className={styles.column_three}>
        <div className={styles.column_three__item}>
          <TextInput
            disabled={false}
            onChange={handleBreadWidth}
            required={false}
            size={'small'}
            type={'tel'}
            value={breadWidth}
          />
        </div>
        <Spacer size={8} />
        <div className={styles.column_three__item}>
          <TextInput
            disabled={false}
            onChange={handleBreadDepth}
            required={false}
            size={'small'}
            type={'tel'}
            value={breadDepth}
          />
        </div>
        <Spacer size={8} />
        <div className={styles.column_three__item}>
          <TextInput
            disabled={false}
            onChange={handleBreadHeight}
            required={false}
            size={'small'}
            type={'tel'}
            value={breadHeight}
          />
        </div>
      </div>
    </div>
  )
})

export default ProductSizeForm
